import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useStyle } from "../context/StyleContext";

const AssignBoothName = () => {
  const [boothName, setBoothName] = useState("");
  const navigate = useNavigate();
  const styles = useStyle();

  const handleInputChange = (e) => {
    setBoothName(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (boothName.trim()) {
      const parentName = "photobooth";
      localStorage.setItem(`${parentName}_boothName`, boothName);
      navigate("/"); // Navigate to the desired page after saving
    } else {
      alert("Please enter a valid booth name.");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center z-10 justify-center">
      <motion.h1
        className="text-6xl font-bold mb-8"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        style={{ fontFamily: styles.fontFamily, color: styles.textColor }}
      >
        Assign Booth Name
      </motion.h1>
      <form onSubmit={handleSubmit} className="max-w-xl w-full">
        <div className="mb-4">
          <input
            type="text"
            value={boothName}
            onChange={handleInputChange}
            placeholder="Enter Booth Name"
            className="w-full px-6 py-5 rounded-lg shadow-lg text-3xl"
            style={{
              fontFamily: styles.fontFamily,
              color: styles.textColor,
              backgroundColor: styles.backgroundColor,
            }}
          />
        </div>
        <motion.button
          type="submit"
          className="w-full px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition duration-300 ease-in-out"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          Save Booth Name
        </motion.button>
      </form>
    </div>
  );
};

export default AssignBoothName;
